module.exports = __webpack_public_path__ + "img/message-network.e6051c2a.svg";